import { render, staticRenderFns } from "./going.vue?vue&type=template&id=00ec56d8&"
import script from "./going.vue?vue&type=script&lang=js&"
export * from "./going.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports